<template>
  <div
    class="custom-slider"
    v-bind:class="{
      'slider-5-elems': customSliderValues.length - 1 === 5,
      'slider-4-elems': customSliderValues.length - 1 === 4,
      'slider-3-elems': customSliderValues.length - 1 === 3,
      'slider-2-elems': customSliderValues.length - 1 === 2,
      'slider-1-elems': customSliderValues.length - 1 === 1
    }"
  >
    <vue-slider
      v-model="customSliderValues"
      :height="50"
      :min="0"
      :max="100"
      :interval="1"
      tooltip="none"
      :min-range="5"
      :drag-on-click="false"
      :disabled="customSliderValues.length <= 2"
      @change="updateCustomValues($event)"
      @dragging="updateCustomValues($event)"
      :process="customSliderProcess"
    >
      <template v-slot:process="{ start, end, style, index }">
        <div class="vue-slider-process" :style="style">
          <div
            :class="[
              'merge-tooltip',
              'vue-slider-dot-tooltip-inner',
              'vue-slider-dot-tooltip-inner-top'
            ]"
          >
            {{
              Math.round(
                customSliderValues[index + 1] - customSliderValues[index]
              )
            }}%
          </div>
        </div>
      </template>
    </vue-slider>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
export default {
  name: "CustomSlider",
  components: { VueSlider },
  props: {
    value: Array,
    colors: Array
  },
  data: () => {
    return {
      customSliderValues: []
    };
  },
  mounted() {
    this.customSliderValues = this.value;
  },
  methods: {
    customSliderProcess(dotsPos) {
      dotsPos[0] = 0;
      dotsPos[this.customSliderValues.length - 1] = 100;
      const arrayMap = [];
      this.customSliderValues.forEach((value, index) => {
        if (index < dotsPos.length - 1) {
          arrayMap.push([
            dotsPos[index],
            dotsPos[index + 1],
            { backgroundColor: this.colors[index] }
          ]);
        }
      });
      return arrayMap;
    },
    updateCustomValues(after) {
      if (this.customSliderValues[0] > 0) {
        this.customSliderValues[0] = 0;
      }
      if (this.customSliderValues[this.customSliderValues.length - 1] < 100) {
        this.customSliderValues[this.customSliderValues.length - 1] = 100;
      }
      this.$emit("input", after);
    }
  }
};
</script>

<style scoped></style>
